/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Col_MeaningInputs */

const en_directory_api_reference_col_meaning = /** @type {(inputs: Directory_Api_Reference_Col_MeaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meaning`)
};

const zh_directory_api_reference_col_meaning = /** @type {(inputs: Directory_Api_Reference_Col_MeaningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`含义`)
};

/**
* | output |
* | --- |
* | "Meaning" |
*
* @param {Directory_Api_Reference_Col_MeaningInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_col_meaning = /** @type {((inputs?: Directory_Api_Reference_Col_MeaningInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Col_MeaningInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_col_meaning(inputs)
	return zh_directory_api_reference_col_meaning(inputs)
});
export { directory_api_reference_col_meaning as "directory.api_reference.col_meaning" }